const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

var init = false;
var swiper;

function swiperCard() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      
      // Function that actually builds the swiper 
      const buildSwiperSlider = sliderElm => {
        const sliderIdentifier = sliderElm.dataset.id;
        const sliderTemplateIdentifier = sliderElm.dataset.templateid;
        
        console.log(sliderIdentifier+"=="+sliderTemplateIdentifier)
        
        if(sliderElm.closest('[data-images]').dataset.images != ""){
          var imageDiv = sliderElm.closest('[data-images]').dataset.images;
          sliderElm.querySelector('.swiper-wrapper').innerHTML = imageDiv;
          return new Swiper(`.p${sliderTemplateIdentifier}${sliderIdentifier}`, {
            centeredSlides: false,
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
                nextEl: `.swiper-button-next-${sliderTemplateIdentifier}-${sliderIdentifier}`,
                prevEl: `.swiper-button-prev-${sliderTemplateIdentifier}-${sliderIdentifier}`
            },
            pagination: {
                el: `.swiper-pagination-${sliderTemplateIdentifier}-${sliderIdentifier}`,
              clickable: true,
            },
        });
        }
      }

      // Get all of the swipers on the page
      const allSliders = document.querySelectorAll('.swiper.media-swiper');
      
      // Loop over all of the fetched sliders and apply Swiper on each one.
      allSliders.forEach(slider => buildSwiperSlider(slider));

    }
  } else if (init) {
    
    init = false;
  }
}

(function () {
	colorSwatches();   
    swiperCard();
    window.addEventListener("resize", swiperCard);
  
})();
